import { Box, Typography } from "@mui/material";
import { RetroButton } from "components/RetroButton";
import { DarkDrawer } from "components/TradeDrawer";
import { MIN_ENTRY_USD } from "consts";
import theme from "theme";
import BasicButton from "v2/components/Buttons/BasicButton";

export const AmountTooSmallDrawer = ({ isOpen, close }: { isOpen: boolean; close: () => void }) => {
  return (
    <DarkDrawer open={isOpen} anchor="bottom" onClose={() => {}} sx={{ zIndex: 2000 }}>
      <Box>
        <Typography variant="mobile-h2">Amount is too small</Typography>
      </Box>
      <Box marginTop={theme.spacing(1)}>
        <Typography variant="mobile-body-m" color={theme.palette.text.secondary}>
          The minimum amount per trade is ${MIN_ENTRY_USD}
        </Typography>
      </Box>
      <Box marginTop={theme.spacing(1)}>
        <BasicButton sx={{ width: "100%" }} onClick={close}>
          <Typography variant="mobile-body-s-heavy">Ok</Typography>
        </BasicButton>
      </Box>
    </DarkDrawer>
  );
};
